import { Component } from "react";
import "../css/Footer.css";

export default class Footer extends Component {
  render() {
    return (
      <div className="footer">
        <p>
          (주)동언테크
          <br />
          &copy; 2023. All rights reserved.
        </p>
      </div>
    );
  }
}
